import { filter, find, findIndex, isEqual, map } from 'lodash';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

import { GameTypeEnum, QuestActionDefinitionDefinitionGameQuizzType, QuestActivityType, QuestionTypeEnum } from '@sifca-monorepo/widget-generator';
import { Subject, takeUntil } from 'rxjs';
import { MobileQuestsService, MobileThemeService } from '@sifca-monorepo/clients';

@Component({
  template:'',
})
export class MobileQuizzComponent implements OnInit {
  private unsubscribeAll: Subject<any> = new Subject<any>();

  @Output() performActivity = new EventEmitter<boolean>();

  darkMode: boolean;
  showAlert: boolean;
  quizzForm: FormGroup;
  gameType: GameTypeEnum;
  selectedChoice: string;
  isButtonDisabled = true;
  isLastActivity: boolean;
  selectedChoices: string[] = [];
  questActivities: QuestActivityType[];
  selectedQuestActivity: QuestActivityType;
  quizz: QuestActionDefinitionDefinitionGameQuizzType;
  activity$ = this.questsService.selectedQuestActivity$;
  
  get choices(): FormArray {
    return this.quizzForm?.get('choices') as FormArray;
  }

  constructor(
    private cd: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private themeService: MobileThemeService,
    private questsService: MobileQuestsService,
  ) {}

  ngOnInit(): void {
    this.questsService.questActivitesByQuest$.pipe(takeUntil(this.unsubscribeAll)).subscribe((questActivitesByQuest) => {
      this.questActivities = questActivitesByQuest;
    });
    this.questsService.selectedQuestActivity$.subscribe((questActivity) => {
      this.selectedQuestActivity = questActivity;
      if (questActivity) {
        this.isLastActivity = this.selectedQuestActivity?.id === this.questActivities[this.questActivities?.length - 1]?.id;
      }
      this.quizz = questActivity?.activity?.action?.definition?.game?.quizz;
      this.gameType = questActivity?.activity?.action?.definition?.game?.gameType;
      this.quizzForm = this.formBuilder.group({
        quizzType: [this.quizz?.quizzType],
        choices: this.formBuilder.array(
          map(this.quizz?.choices, (choice) => {
            return this.formBuilder.group({
              item: [choice?.item],
            });
          }),
        ),
      });
      const initialValues = this.quizzForm.value;
      this.quizzForm.valueChanges.pipe(takeUntil(this.unsubscribeAll)).subscribe((values) => {
        this.isButtonDisabled = isEqual(values, initialValues);
      });
      this.cd.markForCheck();
    });
    this.themeService.darkMode$.pipe(takeUntil(this.unsubscribeAll)).subscribe((darkMode) => {
      this.darkMode = darkMode;
    });
  }

  onChangeMultipleChoice(isChecked: boolean, item: string): void {
    this.showAlert = false;
    if (isChecked) {
      this.selectedChoices.push(item);
    } else {
      const index = this.selectedChoices.indexOf(item);
      if (index > -1) {
        this.selectedChoices.splice(index, 1);
      }
    }
  }

  onChangeSingleChoice(item: string): void {
    this.showAlert = false;
    this.selectedChoice = item;
  }

  nextStep() {
    if (this.isLastActivity) {
      this.performActivity.emit(true);
    } else {
      let index = findIndex(this.questActivities, (item) => item?.id === this.selectedQuestActivity?.id);
      this.questsService.selectedQuestActivity$ = this.questActivities[index + 1];
    }
  }

  navigateNextSlide() {
    if (this.quizz.quizzType === QuestionTypeEnum.SINGLE_CHOICE) {
      const correctAnswer = find(this.quizz?.choices, (choice) => choice?.correct)?.item;
      if (this.selectedChoice === correctAnswer) {
        this.nextStep();
      } else {
        this.showAlert = true;
      }
    } else {
      const correctAnswers = filter(this.quizz?.choices, (choice) => choice?.correct).map((choice) => choice.item);
      if (isEqual(correctAnswers.sort(), this.selectedChoices.sort())) {
        this.nextStep();
      } else {
        this.showAlert = true;
        this.cd.markForCheck();
      }
    }
    this.selectedChoice = null;
    this.selectedChoices = [];
  }

  ngOnDestroy(): void {
    this.selectedChoice = null;
    this.selectedChoices = [];
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
